// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ToggleFormButton from "./toggle_form_button_controller";
application.register("toggle-form-button", ToggleFormButton);

import SpinnerButtonController from "./spinner_button_controller";
application.register("spinner-button", SpinnerButtonController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import AdminDepositsStateController from "./admin/deposit_state_controller";
application.register("admin--deposits-state", AdminDepositsStateController);

import AdminDepositApiStatusController from "./admin/deposit_api_status_controller";
application.register("admin--deposit-api-status", AdminDepositApiStatusController);

import AdminChartsController from "./admin/charts_controller";
application.register("admin-charts", AdminChartsController);

import OpenInNewTabController from "./open_in_new_tab_controller";
application.register("open-in-new-tab", OpenInNewTabController);

